// role-redirect.guard.ts
import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Capacitor } from '@capacitor/core';
import { map, Observable, tap } from 'rxjs';
import { AuthService } from 'src/app/services/auth.service';
import { PreferenceService } from 'src/app/services/preference.service';

@Injectable({ providedIn: 'root' })
export class RoleRedirectGuard implements CanActivate {
    constructor(private router: Router, private authService: AuthService, private preferenceService: PreferenceService) { }

    canActivate(): Promise<boolean> {
        return this.getUserRole().then(async (user: any) => {
            if (this.authService.isClientUser || this.authService.isAdminUser) {
                this.router.navigate([this.authService.getDefaultLandingRoute()]);
            } else if (this.authService.isUser) {
                if(Capacitor.isNativePlatform() && !(await this.preferenceService.getSkipPermission())){
                    this.router.navigate(['/permissions']);
                    } else {
                    this.router.navigate(['/knight/home']);
                }
                // 
                
            } else {
                this.router.navigate(['/login']);
            }
            return false;
        });
    }

    private async getUserRole(): Promise<any> {
        // Simulate async fetch
        const role = await this.authService.getCurrentUserValue(); // Replace with actual logic
        return role;
    }
}